/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

$(document).ready(function(){
    $("[id^=dialog_]").each(function(i,el){
        el = $(el)
        el.modal()
    })
    
})
app.controller('dialog_registerForSchichtCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'Notification', function ($rootScope, $scope, $http, NetworkService, MainService, Notification) {



        $rootScope.$on("render_registerForSchichtCtrl", function () {
            $scope.pairField = {visible: false,
                showPartnerSearchButton: true,
                showPartnerFound: false,
                showPartnerNotFound: false,
                showManyPartnersFound: false,
                foundCode: undefined}
            $scope.tshirtField = {
                visible: false
            }

            $scope.leadField = {visible: false}
            $scope.allowRegister = true;
            $scope.dialogData = MainService.getDialogData("dialog_acceptUserSchichtCtrl")
            var position_id = $scope.dialogData.posObj.position_id;
            NetworkService.getSpecialFields(position_id, function (data) {
                console.log("#+#+#+-.,")
                var fields = data.data
                fields.forEach(function (field) {
                    console.log(field)
                    if (field.type == 1)
                    {
                        $scope.pairField.visible = true;
                        $scope.pairField.name = field.name
                        //$scope.allowRegister = false;
                    } else if (field.type == 2)
                    {
                        $scope.leadField.visible = true;
                    } else if (field.type == 3)
                    {
                        $scope.tshirtField.visible = true;
                    }
                })
            })
        })

        $scope.success = function (msg) {
            Notification.success(msg);
        };

        $scope.searchPartner = function ()
        {
            var names = $scope.pairPartner.split(" ")
            if (names.length == 2)
            {
                var firstName = names[0]
                var secondName = names[1]
                $scope.pairField["showPartnerSearchButton"] = false;
                NetworkService.searchPartner(firstName, secondName, function (data) {
                    if (data.data == 1)
                    {
                        $scope.pairField["showPartnerFound"] = true;
                    } else if (data.data == 2)
                    {
                        $scope.pairField["showManyPartnersFound"] = true;
                    } else if (data.data == -1)
                    {
                        $scope.pairField["showPartnerNotFound"] = true;
                    }
                    $scope.foundCode = data.data
                    $scope.allowRegister = true;
                })
            }


        }
        
        
        $scope.selectFood = function(mahlzeit)
        {
            //mahlzeit.status = 'aktiv'
            $scope.essen.forEach(function(essen){
               essen.status = "inaktiv"
            })
            mahlzeit.status = 'aktiv'
        }
        $scope.registerForSchicht = function ()
        {
            var data = $scope.dialogData

            var email = data.email
            var schicht_id = data.schichtObj.schicht_id
            var position_id = data.posObj.position_id
            var essen = $scope.selectedFood
            var tshirt = $scope.selectedTshirt
            NetworkService.addUserToSchicht(position_id, schicht_id, email, essen, tshirt, function () {
                $scope.success("Du hast dich Erfolgreich für eine Schicht gemeldet")
                $rootScope.$emit("repaint");
            })

            if ($scope.pairField.visible)
            {
                if ($scope.pairPartner == undefined)
                {
                    var firstName = "Kein/e"
                    var secondName = "PartnerIn"
                } else
                {
                    var names = $scope.pairPartner.split(" ")
                    var firstName = names[0]
                    var secondName = names[1]
                }
                NetworkService.registerPairField(position_id, schicht_id, firstName, secondName, email, function (data) {
                    console.log(data)
                })

            }
            if ($scope.leadField.visible)
            {
                var isLeading = $scope.leadingCheckbox
                NetworkService.addLeading(email, position_id, schicht_id, isLeading, function (data) {
                    console.log(data)
                })
            }
            $rootScope.$emit("registerForSchicht");
        }

        var event = MainService.getEventData();
        var event_id = event.event_id;
        NetworkService.getFoodForEvent(event_id, function (data) {
            var food = data.data;
            $scope.essen = [];
            food.forEach(function(essen){
                $scope.essen.push({name: essen, status:"inaktiv"})
            })
            console.log($scope.essen)
            /*if ($scope.essen[0] != undefined)
            {
                $scope.selectedFood = $scope.essen[0]
            }*/
            setTimeout(function () {
                $('select').material_select();
            }, 500)


        })
    }])